'use client';
import { Modal, ModalProps } from '@veneer/core';
import { useTranslation } from 'react-i18next';
import { NamespacesI18n } from '@storefront/i18n';
import Image, { ImageProps } from 'next/image';
import { buildPath } from '@storefront/utils/utils';
import React from 'react';

interface ModalAccessoriesProps extends Partial<ModalProps> {
  i18nPrefix: string;
  styles: { [key: string]: string };
  featuresImg: Partial<ImageProps>;
  featuresImgSecondary?: Partial<ImageProps>;
  bottomImg?: Partial<ImageProps>;
  features: React.ReactNode;
  featuresSecondary?: React.ReactNode;
}

export const ModalAccessories = (props: ModalAccessoriesProps) => {
  const {
    i18nPrefix,
    styles,
    featuresImg,
    featuresImgSecondary,
    bottomImg,
    features,
    featuresSecondary,
    onClose,
    show,
    title,
  } = props;
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG, {
    keyPrefix: i18nPrefix,
  });

  return (
    <Modal
      maxWidth={'fit-content'}
      expanded
      className={styles['modal-container']}
      closeButton
      onClose={onClose}
      show={show}
    >
      <div className={styles['container']} data-testid={title}>
        <div className={styles['modal-header']}>
          <h1 className={`${styles['modal-title']} title-regular`}>
            {t('title')}
          </h1>
          <p className={`subtitle-large ${styles['modal-subtitle']}`}>
            {t('subtitle')}
          </p>
        </div>

        <div className={styles.features}>
          <Image
            src={buildPath(featuresImg.src as string)}
            alt={featuresImg.alt ?? ''}
            width={featuresImg.width}
            height={featuresImg.height}
            quality={featuresImg.quality}
            className={featuresImg.className}
          />
          {features}
        </div>
        {featuresSecondary && (
          <div className={styles.features}>
            {featuresSecondary}
            <Image
              src={buildPath(featuresImgSecondary.src as string)}
              alt={featuresImgSecondary.alt ?? ''}
              width={featuresImgSecondary.width}
              height={featuresImgSecondary.height}
              quality={featuresImgSecondary.quality}
              className={featuresImgSecondary.className}
            />
          </div>
        )}
        {bottomImg && (
          <div className={styles.features}>
            <Image
              src={buildPath(bottomImg.src as string)}
              alt={bottomImg.alt ?? ''}
              width={bottomImg.width}
              height={bottomImg.height}
              quality={bottomImg.quality}
              className={bottomImg.className}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
